import { Box, styled } from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

export const StyledHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2)
}));

export const ResizeButton = styled(IconButton)(() => ({
  width: '40px',
  height: '40px'
}));

export const ResizeOptionButton = styled(IconButton)<{ active: boolean }>(
  ({ theme, active }) => ({
    width: '30px',
    height: '30px',
    backgroundColor: active ? theme.vars.palette.primary.main : 'inherit',
    pointerEvents: active ? 'none' : 'auto',
    '> svg': {
      width: '16px',
      height: '16px'
    }
  })
);

export const ResizePanel = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  backgroundColor: theme.vars.palette.surface.containerLow,
  borderRadius: theme.vars.shape.borderRadius,
  boxShadow: theme.vars.shadows[10],
  '&:after': {
    content: '""',
    width: '12px',
    height: '12px',
    position: 'absolute',
    top: theme.spacing(-1.75),
    right: theme.spacing(5),
    backgroundColor: theme.vars.palette.surface.containerLow,
    border: `1px solid rgba(0, 0, 0, 0.15)`,
    borderRight: 'none',
    borderBottom: 'none',
    transform: 'rotate(45deg)'
  }
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));
